module.exports = __webpack_public_path__ + "img/img2.541c1712.png";